<template>
  <div>
    <PageHeader :title="title" :items="items"/>
    <remaining class="text-end" :total="total" :used="used"></remaining>

    <div class="text-center">
      <show v-if="!loading && img"
            :left-image="defaultImg"
            :right-image="img"
            class="mt-5"
            @newImage="handleNewImage"
            @showEditor="handleShowEditor"
            @downloadImage="handleDownload"
      />
      <div v-else>
        <div class="mt-4 d-flex justify-content-center">
          <h1 class="col-sm-5 d-block page-title">
            {{ $t('pages.bg_remover.page_title') }}
          </h1>
        </div>
        <b-row>
          <div class="mx-auto mt-5" style="max-width: 350px">
            <b-card no-body>
              <VueFileAgent
                  v-model="files"
                  :multiple="false"
                  :uploadUrl="false"
                  :helpText="options.helpText"
                  :accept="options.accept"
                  :deletable="false"
                  :maxSize="options.maxSize"
                  :disabled="loading || disabledQuota"
                  :linkable="true"
                  :errorText="{type: options.typeError,size: options.sizeError}"
                  @select="filesSelected"
              >
                <template v-slot:file-preview="slotProps">
                  <b-skeleton-img></b-skeleton-img>
                </template>

                <template v-slot:file-preview-new>
                  <div class="card-body text-center" key="new">
                    <div class="mt-5 mb-4 d-none d-md-block">
                      <i class="fas fa-layer-group upload-icon"></i>
                    </div>
                    <div>
                      <b-btn variant="primary" size="lg" style="max-width: 225px;" :disabled="disabledQuota">
                        <i class="fas fa-upload"></i>
                        {{ $t('pages.bg_remover.upload_btn') }}
                      </b-btn>
                    </div>
                    <div class="mt-2 mb-4 d-none d-md-block">
                      {{ $t('pages.bg_remover.drop_file') }}
                    </div>

                    <div v-for="(error, index) in fileErrors" :key="index"
                         class="mt-2 mb-4 d-none d-md-block text-danger">
                      {{ error }}
                    </div>

                  </div>
                </template>
              </VueFileAgent>
              <img v-if="img" :src="img">

            </b-card>
          </div>
        </b-row>
      </div>
    </div>
    <image-editor :default-image="defaultImg" :image="img" v-if="!loading && img"/>
  </div>
</template>

<script>
import ImageEditor from "./Components/ImageEditor";
import BgRemovalService from "../../../Services/Api/BgRemovalService";
import QuotaMixin from "../../../mixins/QuotaMixin";
import Show from "./Components/Show";

export default {
  name: "Index",
  components: {Show, ImageEditor},
  mixins: [QuotaMixin],
  page() {
    return {
      title: this.$t('pages.bg_remover.main_title'),
      meta: [
        {
          name: "description",
          content: this.$t('common.app_title')
        }
      ]
    }
  },
  data() {
    return {
      title: this.$t('pages.bg_remover.main_title'),
      items: [
        {
          text: this.$t('pages.bg_remover.items.first'),
          href: "/",
        },
        {
          text: this.$t('pages.bg_remover.items.second'),
          active: true,
        },
      ],
      files: [],
      fileRecords: [],
      img: null,
      defaultImg: null,
      options: {
        accept: 'image/jpg,image/jpeg,image/png',
        maxSize: '2MB',
        typeError: this.$t('pages.bg_remover.file_options.typeError'),
        sizeError: this.$t('pages.bg_remover.file_options.sizeError'),
        helpText: this.$t('pages.bg_remover.file_options.helpText'),
        acceptText: '(png, jpeg, jpg, only - 2mb max)'
      },
      loading: false,
      fileErrors: [],
      quotaType: 'bg_remover',
    }
  },
  methods: {
    handleShowEditor() {
      this.$bvModal.show('image-editor-modal')
    },
    handleNewImage() {
      this.img = null
      this.defaultImg = null
      this.fileRecords = []
      this.files = []
    },
    async handleRequest() {
      this.loading = true
      const formData = new FormData()
      formData.append('image', this.fileRecords[0]?.file)
      await BgRemovalService.store({payload: formData}).then((res) => {
        const image = res.data
        this.img = "data:image/png;base64," + Buffer.from(image, 'binary').toString('base64')
        this.getSubscriptionQuota()
      }).finally(() => {
        this.loading = false
      })
    },
    checkError(files) {
      let hasError = false
      files.forEach((file) => {
        if (file.error?.size) {
          this.fileErrors.push(this.options.sizeError)
          hasError = true
        } else if (file.error?.type) {
          this.fileErrors.push(this.options.typeError)
          hasError = true
        }
      })
      if (hasError) {
        this.fileRecords = []
        this.files = []
      }
    },
    handleDownload() {
      const a = document.createElement("a")
      a.href = this.img
      a.download = `Image-${Date.now()}.png`
      a.click()
    },
    async filesSelected(fileRecordsNewlySelected) {
      this.fileErrors = []
      this.fileRecords = []
      this.checkError(fileRecordsNewlySelected)
      const validFileRecords = fileRecordsNewlySelected.filter((fileRecord) => !fileRecord.error);
      this.fileRecords = this.fileRecords.concat(validFileRecords);

      if (this.fileRecords.length > 0 && this.fileErrors.length < 1) {
        this.defaultImg = await this.$helpers.getBase64String(this.fileRecords[0]?.file)
        await this.handleRequest()
      }
    },

  },
}
</script>

<style scoped>
.upload-icon {
  color: #DDDFE1;
  font-size: 7em;
}

.page-title {
  font-size: 3rem;
  font-weight: 700
}

/deep/ .vue-file-agent {
  border-radius: 6px !important;
  border-color: #f1f1f1 !important;
}

/deep/ .file-preview-wrapper:before {
  background: none !important;
}

/deep/ .file-preview-wrapper {
  width: 100% !important;
}
</style>